import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useMemo } from "preact/hooks";
import PlanGroupInputRadio from "./PlanGroupInputRadio";
const PreserveGroupComponent = ({ planGroups, onChange, value }) => {
    const handleChange = (selected) => {
        onChange(selected);
    };
    const visible = useMemo(() => {
        return planGroups.length > 0;
    }, [planGroups]);
    return (_jsxs("section", Object.assign({ className: `SchedulePayComponent__container ${visible ? '' : 'hide'}`, id: "PreserveGroupComponent" }, { children: [_jsxs("h4", Object.assign({ class: "content__title" }, { children: [_jsx("span", { class: "heading" }, void 0), "\u4E88\u7D04\u5BFE\u8C61"] }), void 0),
            _jsxs("div", Object.assign({ class: "field control" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u3054\u5E0C\u671B\u306E\u4E88\u7D04\u5BFE\u8C61\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044" }), void 0),
                    _jsx("ul", Object.assign({ class: "ml3" }, { children: planGroups.map(m => _jsx(PlanGroupInputRadio, { onInput: handleChange, planGroup: m, value: value?.id }, m.id)) }), void 0)] }), void 0)] }), void 0));
};
export default PreserveGroupComponent;
